import React from 'react';
import { BiomeasurePonds, MeasurementPonds } from 'modules/dashboard/graphs';
import Box from 'v2/components/UI/Box';
import Supplies from './components/graphics/Supplies';
import NurseryMortality from './components/graphics/NurseryMortality';
import HealthAnalysis from './components/graphics/HealthAnalysis';
import WaterQualityParameters from './components/graphics/WaterQualityParameters';
import BiometricsParameters from './components/graphics/BiometricsParameters';
import BiometricsNurseries from './components/graphics/BiometricsNurseries';
import WaterAnalysisNurseries from './components/graphics/WaterAnalysisNurseries';

const Dashboard: React.FC = () => {
  return (
    <Box flexDirection="column" gap={20}>
      <Supplies />
      <NurseryMortality />
      <HealthAnalysis />
      <WaterQualityParameters />
      <BiometricsParameters />
      <BiometricsNurseries />
      <WaterAnalysisNurseries />
    </Box>
  );
};

export default Dashboard;
